import combined_status from "dictionaries/combined_status.json";
import createOptions from "utils/createOptions";

export const combinedStatusOptions = createOptions(combined_status);

export const onlyErirOptions = combinedStatusOptions.map((item) => ({
  ...item,
  isDisabled: !(item.value === 4 || item.value === 5 || item.value === 5)
}));
